import React from "react";
import { formatDate } from "../../utilities/utilities";

function DetailCard({ title, value }) {
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 transition-all duration-200 hover:shadow-md hover:-translate-y-1">
      <div className="text-sm font-medium text-slate-500 mb-2">
        {title}
      </div>

      <div className="text-base font-semibold text-slate-800 break-words">
        {value || "-"}
      </div>
    </div>
  );
}

function ContractDetail({
  jobOrder,
  typeOfAgreement,
  termOfContractInDays,
  dateOfContract,
  endDate,
  location,
}) {
  return (
    <div className="mt-8">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        <DetailCard
          title="Job Order"
          value={jobOrder}
        />

        <DetailCard
          title="Type"
          value={typeOfAgreement}
        />

        <DetailCard
          title="Start Date"
          value={formatDate(dateOfContract)}
        />

        <DetailCard
          title="Term (In Days)"
          value={termOfContractInDays}
        />

        <DetailCard
          title="End Date"
          value={formatDate(endDate)}
        />

        <DetailCard
          title="Business Unit"
          value={location}
        />
      </div>
    </div>
  );
}

export default ContractDetail;